import { isHTTPError, type Options } from 'ky'

import type { CsrfTokenResponse } from './types'

import { CSRF_KEY } from '../config/constants'
import { useLocalStorage } from '../lib/browser'
import { apiInstance } from './api-instance'

export async function postRequest<SuccessResponseData, ErrorResponseData>(
    url: string,
    payload?: Record<string, boolean | number | number[] | string | string[]>,
    options?: Options
) {
    const {
        value: { headerName, token },
    } = useLocalStorage<CsrfTokenResponse>(CSRF_KEY, {
        headerName: '',
        parameterName: '',
        token: '',
    })

    try {
        const response = await apiInstance.post(url, {
            ...(options?.body ? {} : { json: payload }),
            ...options,
            headers: {
                [headerName]: token,
                ...(options?.headers ?? {}),
            },
        })

        const text = await response.text()
        const data = text ? (JSON.parse(text) as SuccessResponseData) : null

        return { data, response }
    } catch (error) {
        if (isHTTPError(error)) {
            let errorData: ErrorResponseData | null = null

            try {
                // Всегда читаем тело — это важно для предотвращения утечек
                const errorText = await error.response.text()

                // Пытаемся парсить JSON только если строка не пустая
                errorData = errorText ? JSON.parse(errorText) : null
            } catch {
                // Если JSON сломан, просто игнорируем
                errorData = null
            }

            return {
                data: errorData ?? {
                    error: error.response.status,
                    message: 'Server Error',
                },
                status: error.response.status,
            }
        }

        return {
            data: {
                error: 666,
                message: 'Unknown error',
            } as ErrorResponseData,
            response: null,
            status: 0,
        }
    }
}
